// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:8081c244-5d22-4657-b98f-2d6eff43a002",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_DpP7wnWIx",
    "aws_user_pools_web_client_id": "64lfvrmavghmrb5pcfj7libcg1",
    "oauth": {},
    "aws_content_delivery_bucket": "theplantdeliverylive-20200413201021-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d3rrvqkwm1cpyy.cloudfront.net"
};


export default awsmobile;
